// #region imports
import React, { FC, Suspense } from 'react';

import useMobile from 'hooks/useMobile';
import { IMenuItem } from 'models/types';
// #endregion

const MobileMenu = React.lazy(() => import('./components/Mobile'));
const DesktopMenu = React.lazy(() => import('./components/Desktop'));

interface IProps {
  className?: string;
  items: IMenuItem[];
}

const Header: FC<IProps> = ({ ...rest }) => {
  const { isMobile } = useMobile();
  if (isMobile) {
    return (
      <Suspense>
        <MobileMenu { ...rest } />
      </Suspense>
      );
  }

  return (
    <Suspense>
      <DesktopMenu { ...rest } />
    </Suspense>
  );

};

export default Header;
